import type { TimeOffAttachmentDto } from '../lib/types';

function formatSize(bytes: number | null): string {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

/** Read-only list of a request's attachments with per-file view/download links. */
export function TimeOffAttachmentList({
  requestId,
  attachments,
  className,
}: {
  requestId: number;
  attachments: TimeOffAttachmentDto[];
  className?: string;
}) {
  if (attachments.length === 0) {
    return null;
  }
  return (
    <div className={className}>
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Attachments</p>
      <ul className="mt-1 space-y-1">
        {attachments.map((att) => (
          <li key={att.id} className="text-sm">
            <a
              href={`/api/v1/time-off/requests/${requestId}/attachments/${att.id}`}
              target="_blank"
              rel="noreferrer"
              className="text-brand-hover underline underline-offset-2 hover:text-brand-800"
            >
              {att.fileName ?? `attachment-${att.id}`}
            </a>
            {att.sizeBytes != null ? (
              <span className="ml-2 text-xs text-slate-400">{formatSize(att.sizeBytes)}</span>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
